import React, { useState, useEffect, useCallback, memo } from "react";
import {
  GoogleMap,
  useJsApiLoader,
  MarkerF,
  InfoWindow,
} from "@react-google-maps/api";
import "./style.scss";
import { useNavigate } from "react-router-dom";

const ShowGoogleMap = (props) => {
  const navigate = useNavigate();
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_APIKEY,
  });

  const [map, setMap] = useState(null);
  const [activeMarker, setActiveMarker] = useState(null);
  const [centerMarker, setCenterMarker] = useState(props.dataCenter);
  const [locationStore, setLocationStore] = useState("");

  const onLoad = useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds(centerMarker);
    map.fitBounds(bounds);
    setMap(map);
  }, []);

  const onUnmount = useCallback(function callback(map) {
    setMap(null);
  }, []);

  useEffect(() => {
    setCenterMarker(props.dataCenter);
  }, [props.dataCenter]);

  const handleActiveMarker = (id, item) => {
    if (!activeMarker) {
      setActiveMarker(null);
    }
    setActiveMarker(id);
    setLocationStore(`${item.name}/${item.position.lat},${item.position.lng}`);
  };

  const handleCloseMarker = () => {
    setActiveMarker(null);
  };

  const handleClickInfoWindow = (data) => {
    if (data.redirectDetail) {
      const voucherPathDetail = `/reward/discount/${data.url}/detail/${data.key}`;
      navigate(voucherPathDetail);
    }
  };

  return isLoaded ? (
    <GoogleMap
      mapContainerClassName="map-container"
      center={centerMarker}
      zoom={1}
      onLoad={onLoad}
      onUnmount={onUnmount}
      options={{
        streetViewControl: false,
        mapTypeControl: false,
      }}
    >
      {props.listMarker.map((item, index) => (
        <MarkerF
          key={index}
          position={item.position}
          onClick={() => {
            handleActiveMarker(index, item);
          }}
        >
          {activeMarker === index ? (
            <InfoWindow onCloseClick={() => handleCloseMarker()}>
              <div
                onClick={() => {
                  handleClickInfoWindow(item);
                }}
              >
                <div className="marker-name">{item.name}</div>
                <div className="marker-address">{item.address}</div>
                <a
                  className="marker-link"
                  href={`http://www.google.com/maps/place/${locationStore}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  Tampilan di Google Maps
                </a>
              </div>
            </InfoWindow>
          ) : null}
        </MarkerF>
      ))}
    </GoogleMap>
  ) : (
    <></>
  );
};

export default memo(ShowGoogleMap);
